<template>
  <footer class="d-flex align-items-center justify-content-between flex-wrap gap-3 border-top bg-white px-4 py-3">
    <div class="d-flex align-items-center gap-2 text-muted small">
      <span>Show</span>
      <select
        class="form-select form-select-sm w-auto"
        :value="pageSize"
        :disabled="totalRows === 0"
        @change="$emit('update:pageSize', Number($event.target.value))"
      >
        <option v-for="option in pageSizeOptions" :key="option" :value="option">{{ option }}</option>
      </select>
      <span>entries</span>
    </div>

    <div class="d-flex align-items-center gap-3">
      <span class="text-muted small">
        Showing {{ pageStart }} to {{ pageEnd }} of {{ totalRows }}
      </span>
      <nav class="d-inline-flex align-items-center gap-2" aria-label="Table pagination">
        <button
          type="button"
          class="btn btn-sm bg-white border rounded-2"
          :disabled="page <= 1"
          @click="$emit('update:page', page - 1)"
        >
          Previous
        </button>
        <span class="small text-muted">Page {{ page }} of {{ totalPages }}</span>
        <button
          type="button"
          class="btn btn-sm bg-white border rounded-2"
          :disabled="page >= totalPages"
          @click="$emit('update:page', page + 1)"
        >
          Next
        </button>
      </nav>
    </div>
  </footer>
</template>

<script src="./table_pagination.js"></script>
